var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ma-2" },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "text-center mb-3" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.newMachineDialog = true
                    },
                  },
                },
                [_vm._v(" Create New Machine ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-icon",
                {
                  staticClass: "mr-3",
                  attrs: { color: "black", size: "30" },
                  on: { click: _vm.backToAccount },
                },
                [_vm._v("mdi-keyboard-backspace")]
              ),
              _vm._v(" Machines (" + _vm._s(_vm.account.Name) + ") "),
            ],
            1
          ),
          _c(
            "v-row",
            {
              directives: [
                {
                  name: "resize",
                  rawName: "v-resize",
                  value: _vm.onResize,
                  expression: "onResize",
                },
              ],
              staticStyle: { height: "calc(100% - 70px)" },
              attrs: { align: "center", justify: "center", "no-gutters": "" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass:
                    "fill-height d-xl-flex d-sm-flex d-lg-flex d-md-flex flex-column",
                  attrs: { cols: "12" },
                },
                [
                  _c("v-data-table", {
                    attrs: {
                      height: _vm.windowSize.y - 270,
                      headers: _vm.headers,
                      "footer-props": {
                        itemsPerPageOptions: [10, 25],
                      },
                      items: _vm.machines,
                      loading: _vm.loading,
                      "loading-text": "Loading... Please wait",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "footer.page-text",
                        fn: function (props) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(props.pageStart) +
                                "-" +
                                _vm._s(props.pageStop) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.CertificateStatus",
                        fn: function ({ item }) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getCertificateStatus(
                                    item.CertificateStatus
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  color: "action-button-color",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.createCertificateDialog(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-certificate ")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm.getOperation(item.CertificateStatus)
                                  ? _c("span", [_vm._v("Recreate")])
                                  : _c("span", [_vm._v("Create")]),
                              ]
                            ),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  disabled:
                                                    _vm.disableRevokeAction(
                                                      item.CertificateStatus
                                                    ),
                                                  color: "action-button-color",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.revokeCertificateDialog(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-window-close ")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Revoke")])]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.newMachineDialog
        ? _c("NewMachine", {
            attrs: { account: _vm.account },
            on: { newmachinecredential: _vm.newMachineCredential },
            model: {
              value: _vm.newMachineDialog,
              callback: function ($$v) {
                _vm.newMachineDialog = $$v
              },
              expression: "newMachineDialog",
            },
          })
        : _vm._e(),
      _vm.newCertificateDialog
        ? _c("CreateCertificate", {
            attrs: { machine: _vm.selectedMachine },
            on: { newmachinecredential: _vm.newMachineCredential },
            model: {
              value: _vm.newCertificateDialog,
              callback: function ($$v) {
                _vm.newCertificateDialog = $$v
              },
              expression: "newCertificateDialog",
            },
          })
        : _vm._e(),
      _vm.machineCredentialCertificate
        ? _c("MachineCertificate", {
            model: {
              value: _vm.machineCredentialCertificate,
              callback: function ($$v) {
                _vm.machineCredentialCertificate = $$v
              },
              expression: "machineCredentialCertificate",
            },
          })
        : _vm._e(),
      _vm.revokeCertDialog
        ? _c("RevokeCertificate", {
            attrs: { machine: _vm.selectedMachine },
            on: { update: _vm.initialize },
            model: {
              value: _vm.revokeCertDialog,
              callback: function ($$v) {
                _vm.revokeCertDialog = $$v
              },
              expression: "revokeCertDialog",
            },
          })
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "primary", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackBar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackBar,
            callback: function ($$v) {
              _vm.snackBar = $$v
            },
            expression: "snackBar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackBarText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }